module.exports = __webpack_public_path__ + "static/media/aws_cloud_practitioner.23124328.png";